(function () {
  var STORAGE_KEY = 'sthetix-promo-popup-dismissed-until';
  var SEEN_CATEGORIES_KEY = 'sthetix-promo-popup-seen-categories';

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('[data-sthetix-promo-popup]');
    if (!popup) return;

    var category = popup.dataset.category || '';
    var dismissedUntil = Number(localStorage.getItem(STORAGE_KEY) || 0);
    var cooldownActive = Date.now() < dismissedUntil;

    var seenCategories = [];
    if (cooldownActive) {
      try {
        seenCategories = JSON.parse(localStorage.getItem(SEEN_CATEGORIES_KEY) || '[]');
      } catch (e) {
        seenCategories = [];
      }
    }

    var isNewCategory = category && seenCategories.indexOf(category) === -1;

    if (cooldownActive && !isNewCategory) return;

    var delay = Number(popup.dataset.delay || 0);
    var expireHours = Number(popup.dataset.expireHours || 1);
    var img = popup.querySelector('.sthetix-promo-popup__image');

    function openPopup() {
      if (img && img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-visible');
      });
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('is-visible');
      document.body.style.overflow = '';

      var expiry = Date.now() + expireHours * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(expiry));

      var updatedSeen = cooldownActive ? seenCategories.slice() : [];
      if (category && updatedSeen.indexOf(category) === -1) {
        updatedSeen.push(category);
      }
      localStorage.setItem(SEEN_CATEGORIES_KEY, JSON.stringify(updatedSeen));

      window.setTimeout(function () {
        popup.hidden = true;
      }, 300);
    }

    popup.querySelectorAll('[data-sthetix-promo-popup-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        closePopup();
      }
    });

    window.setTimeout(openPopup, delay);
  });
})();
